/** Route screens, shared by App (routes) and DeviceFrame (split columns) so both use the same warmed-up chunk. */
import { lazyWithPreload } from './lazyPreload';

export const HomeView = lazyWithPreload(() => import('@/features/home/HomeView'));
export const ClientChatView = lazyWithPreload(() => import('@/features/chat/ClientChatView'));
export const CopiedPhoneView = lazyWithPreload(() => import('@/features/phone/shell/CopiedPhoneView'));
/** First launch only: kept out of the main chunk. */
export const ColdOpenScreen = lazyWithPreload<object>(() => import('./layout/ColdOpenScreen'));
